import { render, staticRenderFns } from "./ItemsListManage.vue?vue&type=template&id=e8784a30&scoped=true"
import script from "./ItemsListManage.vue?vue&type=script&lang=js"
export * from "./ItemsListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8784a30",
  null
  
)

export default component.exports